import Vue from 'vue'
import Vuex from 'vuex'

import { user } from './user'

import { org } from './org'

import { JMenu } from '../components/JComponents/JMenu/store'

import { JGridCtrl } from "../components/JComponents/JGridCtrl/store";

import { JDictionary } from "../components/JComponents/JDictionary/store";

import { JLinkAddress } from "@/components/JComponents/JLinkAddress/store";

import { JCascader } from "@/components/JComponents/JCascader/store";

import { LedgerConfig } from "@/extend/LedgerConfig/store";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...user.state,
    ...org.state,
  },
  mutations: {
    ...user.mutations,
    ...org.mutations
  },
  actions: {
    ...user.actions,
    ...org.actions
  },
  modules: {
    JMenu,
    JGridCtrl,
    JDictionary,
    JLinkAddress,
    JCascader,
    LedgerConfig
  }
})
